import { breakpoints } from 'theme/MuiThemeProvider/breakpoints';
import { customTheme } from 'theme/MuiThemeProvider/theme';

export const styles = {
  listWrap: {
    marginBottom: '40px',
    display: 'flex',
    gap: '24px',
    flexWrap: 'wrap',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      marginBottom: '32px',
      gap: '12px 20px',
    },
  },
  title: {
    marginBottom: '24px',
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '28px',
    color: customTheme.custom.black.B100,

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      marginBottom: '10px',
      fontSize: '14px',
      lineHeight: '18px',
    },
  },
};
